module.exports = __webpack_public_path__ + "img/logob.af624bbe.png";